import { Component, Input, OnChanges, OnInit } from '@angular/core';
import * as echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/pie'
// import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { __values } from 'tslib';
@Component({
  selector: 'app-dashboard-pie-chart',
  templateUrl: './dashboard-pie-chart.component.html',
  styleUrls: ['./dashboard-pie-chart.component.scss']
})
export class DashboardPieChartComponent implements OnInit, OnChanges {
  @Input() observationByRiskRating: any
  @Input() totalActiveLicenseList: any[] = []
  totalActiveLicenseListCopy: any[] = []
  // find the sum of all data values
  sum: any = 0;
  myChart: any;
  public legendName: any;
  public legendBoelean: any;
  constructor() { }
  ngOnInit(): void {
    this.myChart = echarts.init(document.getElementById('main'));
    // this.myChart = echarts.init(document.getElementById('main'));
    this.totalActiveLicenseList.forEach((element, ind) => {
      this.totalActiveLicenseList[ind].value = this.totalActiveLicenseList[ind].license_count
      this.totalActiveLicenseList[ind].name = this.totalActiveLicenseList[ind].company
    });
    this.totalActiveLicenseList.forEach((item) => {
      this.totalActiveLicenseListCopy.push(item)
    });
    this.sum = this.totalActiveLicenseList.reduce((prev, current) => prev + current.value, 0);
  }

  ngOnChanges() {
    this.totalActiveLicenseList.forEach((item) => {
      this.totalActiveLicenseListCopy.push(item)
    });
    this.myChart?.on('legendselectchanged', (params:any) => {
      // this.totalActiveLicenseList = []
      this.sum = 0;
      this.option.title['text']= ''
      this.totalActiveLicenseListCopy.forEach((item) => {
        if (params.name === item.name && params.selected[params.name] == true) {
          this.totalActiveLicenseList.push(item)
        }
      });
      this.totalActiveLicenseList.forEach((ele, ind) => {
        if (params.name === ele.name && params.selected[params.name] == false) {
          this.totalActiveLicenseList.splice(ind, 1)
        }
      })
      if (this.totalActiveLicenseList?.length > 0) {
        this.sum = this.totalActiveLicenseList.reduce((prev, current) => prev + current.value, 0);
        this.option.title['text'] = this.sum + "\n" + 'Total'
      }
      else {
        this.sum = 0;
        this.option.title['text'] = this.sum + "\n" + 'Total'
      }
      this.myChart.setOption(this.option);
    });
    this.option = { ...this.option };
    this.totalActiveLicenseList.forEach((element, ind) => {
      this.totalActiveLicenseList[ind].value = this.totalActiveLicenseList[ind].license_count
      this.totalActiveLicenseList[ind].name = this.totalActiveLicenseList[ind].company
      delete (this.totalActiveLicenseList[ind].company)
      delete (this.totalActiveLicenseList[ind].license_count)
    });
    this.sum = this.totalActiveLicenseList.reduce((prev, current) => prev + current.value, 0);
    this.option.series['data'] = this.totalActiveLicenseList.map((item) => { return item })
    this.option.title['text'] = this.sum + "\n" + 'Total'
  }
  option: any = {
    title: {
      text:'',
      left: 'center',
      top: '36%',
      triggerEvent: true,
      textStyle: {
        // color: '#006699',
        fontSize: '15',
        display: 'block',
        innerWidth: '50%'
      },
    },
    toolbox: {
      // right:'20%',
      padding: [0, 0, 5, 0],
      itemSize: 13,
      iconStyle: {
        borderColor: "black",
        borderWidth: 1.1
      },
      feature: {
        // saveAsImage: {}
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: screenLeft,
      width: 100,
      top: 15,
      itemGap: 10,
      itemWidth: 15,
      itemHeight: 15,
      textStyle: {
        fontSize: '14',
        // padding:'2'
      },
    },

    series: {
      name: 'Active License Count Of',
      type: 'pie',
      // left: '10%',
      top: 0,
      bottom: '15%',

      min: 100,
      max: 100,
      minSize: '0%',
      maxSize: '100%',
      radius: ['90%', '50%'],
      sort: 'descending',
      gap: 2,
      label: {
        show: true,
        position: 'inside',
        fontWeight: 'bold',
        fontSize: '13',
        formatter: function (d) {
          return d.value;
        }
      },
      labelLine: {
        length: 10,
        lineStyle: {
          width: 1,
          type: 'solid'
        }
      },
      itemStyle: {
        // borderColor: '#fff',
        // borderWidth: 1
      },
      emphasis: {
        label: {
          // fontSize: 20
        }
      },
      data: []
    },
    color: [
      '#006699',
      '#16C599',
      '#E8DD11',
      '#F05457',
      '#74C1FF',
      '#2196F3'
    ]
  };
}
